<template>
    <div>
        <kDialog v-show="showPopup" :title="'Stage Selection'" @close="cancel">
            <p>Select the stage to move the encounter to</p>
            <dropdownlist :data-items="stages"
                          :text-field="'text'"
                          :data-item-key="'id'"
                          :value="selectedValue"
                          :default-item="selectedValue"
                          :popup-settings="{ className: 'dropDownWidthFix'}"
                          @change="onStageSelectionChange">
            </dropdownlist>

            <Checkbox v-show="showCheckbox" id="assignToAuditor"  :checked="assignToAuditor" style="height:50px" label="Assign to prior auditor" @change="onCheckboxChange" />
            <kDialogActionsbar layout="end">
                <KButton :theme-color="'primary'" @click='confirmChange'>Confirm</KButton>
                <KButton :theme-color="'info'" :fill-mode="'outline'" @click='cancel'>Cancel</KButton>
            </kDialogActionsbar>
        </kDialog>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, inject, ref, watch} from 'vue';
    import { Dialog as kDialog, DialogActionsBar as kDialogActionsbar } from '@progress/kendo-vue-dialogs';
    import { Button as KButton} from '@progress/kendo-vue-buttons';
    import { DropDownList as dropdownlist } from "@progress/kendo-vue-dropdowns";
    import { Checkbox } from "@progress/kendo-vue-inputs";
    import logger  from "./../../modules/logger";
    import { fetchAPI } from '../../modules/fetchAPI';


    const props = defineProps(['replaceClientWithCoder', 'encounterId', 'workpoolId', 'currentStage', 'showDialog','assignToPriorAuditor']);
    const emit = defineEmits(['changed','cancelled']);
    const infoDialog = inject('$infoDialog');
    var stages = [
                    { text: "Audit", id: "Audit" },
                    { text: "QC", id: "QC" },
                    { text: "Client", id: "Client" },
                    { text: "Manager", id: "Manager" }
                ];

    const selectedValue = ref({ text: "Select Stage", id: "select" });
    const isAssigned = ref(false)
    const showPopup = ref(false);
    const showCheckbox = ref(false);
    const assignToAuditor = ref(props.assignToPriorAuditor);
    var stageIndex = -1;




    watch(() => props.showDialog, (newValue) => { updated(newValue); });
    watch(() => props.assignToPriorAuditor, (newValue) => { assignToAuditor.value = newValue; });

    function updated(newValue){
        showPopup.value = newValue;

        refreshStages();

        if (props.replaceClientWithCoder !== null && props.replaceClientWithCoder) {
            stages[2].text = "Coder";
        }
        stageIndex = stages.findIndex(function (element) {
            return element.text == props.currentStage;
        });

        if (stageIndex >= 0) {
            stages.splice(stageIndex, 1);
        }


    }

    function refreshStages() {
        stages.length=0;
        stages = [
            { text: "Audit", id: "Audit" },
            { text: "QC", id: "QC" },
            { text: "Client", id: "Client" },
            { text: "Manager", id: "Manager" }
        ];
        selectedValue.value = { text: "Select Stage", id: "select" };
        showCheckbox.value = false;
        // Reset checkbox value when stages are refreshed
        assignToAuditor.value = props.assignToPriorAuditor;
    }

    function onStageSelectionChange(e){
        selectedValue.value = e.value;
        if (e.value.text == "Audit") {
            showCheckbox.value = true;
            // Reset checkbox value when switching to Audit
            assignToAuditor.value = props.assignToPriorAuditor;
        }
        else {
            showCheckbox.value = false;
        }

    }

    const onCheckboxChange = (e) => {
        assignToAuditor.value = e.value;
    };

    function toggleDialog() {
        showPopup.value = !showPopup.value;
    }

    function cancel() {
        toggleDialog();
        emit("cancelled");
    }

    function confirmChange() {
        let request = {
            encounterId: props.encounterId,
            workpoolId: props.workpoolId,
            stage: selectedValue.value.id,
            assignToPriorAuditor: assignToAuditor.value
        }
        fetchAPI('api/Encounter/ChangeStage', request)
            .then(async response => {
                if (!response.ok) {
                    const problem = await response.json().catch(() => null);
                    const reason = problem ? (problem.message || problem.Message) : null;
                    throw new Error(reason || `HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                toggleDialog();
                if (props.replaceClientWithCoder !== null
                    && props.replaceClientWithCoder
                && request.stage == 'Client')
              {
                    emit("changed", { encounterId: request.encounterId, stage: "Coder", actionResult: data });
                } else {
                    emit("changed", { encounterId: request.encounterId, stage: request.stage, actionResult: data });
                }
            })
            .catch(error => {
                logger.error('Error: ' + error);
                toggleDialog();
                infoDialog.value = {
                    Title: 'Change Stage',
                    Message: error.message,
                    OkText: 'OK',
                    ClosedAction: () => { },
                    Show: true
                };
            })
            .finally(() => {
            });
    }

</script>
